import { jsxs, jsx } from 'react/jsx-runtime';
import { cssVar } from '../theme/variables.js';
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import { styled, css } from 'styled-components';
import { ButtonIcon } from './Button.js';
import { CloseIcon } from '@fabric-app/icons/icons';

const OverlayContainer = styled(motion.div).attrs((props) => {
  return {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    ...props
  };
}).withConfig({
  displayName: "Overlay__OverlayContainer",
  componentId: "sc-f93851aa-0"
})([
  `position:fixed;top:var(--safe-margin-offset-desktop,0px);left:0;right:0;bottom:0;background:`,
  `;padding-bottom:env(safe-area-inset-bottom);z-index:50;display:flex;flex-direction:column;align-items:stretch;height:100dvh;`,
  ``
], cssVar["color-bg-primary"], (p) => {
  switch (p.background) {
    case "primary-semitransparent": {
      return css([
        `background:hsla(`,
        `,0.8);`
      ], cssVar["color-bg-primary-hsl"]);
    }
    default: {
      return css([
        `background:`,
        `;`
      ], cssVar["color-bg-primary"]);
    }
  }
});
const InnerContainer = styled(motion.div).attrs({
  initial: {
    scale: 0.95
  },
  animate: {
    scale: 1
  },
  exit: {
    scale: 0.95,
    y: 5
  }
}).withConfig({
  displayName: "Overlay__InnerContainer",
  componentId: "sc-f93851aa-1"
})([
  `display:flex;flex-direction:column;align-items:stretch;min-height:100%;flex-grow:1;`
]);
const CloseButton = styled(ButtonIcon).withConfig({
  displayName: "Overlay__CloseButton",
  componentId: "sc-f93851aa-2"
})([
  `position:fixed;right:1.25rem;top:calc(env(safe-area-inset-top) + 1.25rem);z-index:1001;`
]);
const Overlay = /* @__PURE__ */ forwardRef(({ children, background, onClose, ...rest }, ref) => {
  if (typeof window === "undefined") {
    return null;
  }
  return /* @__PURE__ */ createPortal(/* @__PURE__ */ jsxs(OverlayContainer, {
    ref,
    background,
    ...rest,
    children: [
      onClose && /* @__PURE__ */ jsx(CloseButton, {
        onClick: onClose,
        children: /* @__PURE__ */ jsx(CloseIcon, {})
      }),
      /* @__PURE__ */ jsx(InnerContainer, {
        children
      })
    ]
  }), document.body);
});
Overlay.displayName = "Overlay";

export { Overlay };
//# sourceMappingURL=Overlay.js.map
